export function formatDate(val, withTime = false) {
  if (!val) return '';
  const str = String(val);
  return withTime ? str.substring(0, 16) : str.substring(0, 10);
}
